import React, { useState } from 'react';
import { MdOutlineContentCopy } from 'react-icons/md';
import './ChatToolBar.scss';
import Tooltip from '@srm/ui/tooltip';
import type { ChatAIFormMessage } from './ChatAIFormMessage';
import { sendNotification } from '@srm/ui/lib/notifications';

export interface IChatToolBarProps {
    message: Pick<ChatAIFormMessage, 'id' | 'message'>;
}

const ChatToolBar = ({ message }: IChatToolBarProps) => {
    const [titleCopy, setTitleCopy] = useState<string>('Копировать');

    const onCopy = (event: React.MouseEvent) => {
        let htmlString = message.message;
        event.stopPropagation();
        if (htmlString) {
            let div = document.createElement('div');
            div.innerHTML = htmlString;
            let text = div.textContent || div.innerText || '';
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    setTitleCopy('Скопировано');
                    setTimeout(() => {
                        setTitleCopy('Копировать');
                    }, 3000);
                })
                .catch(() => {
                    sendNotification({
                        message: 'Не удалось скопировать текст',
                        variant: 'red',
                    });
                });
        }
    };

    return (
        <div className="chatAi-toolbar">
            <Tooltip openDelay={100} background="black" position="top" label={titleCopy}>
                <div
                    className=" chatAi-toolbar-icon-button  chatAi-toolbar-icon-button--sizing-container"
                    aria-disabled="false"
                    onClick={onCopy}
                >
                    <div className="chatAi-toolbar-icon">
                        <MdOutlineContentCopy size={16} aria-hidden />
                    </div>
                </div>
            </Tooltip>
        </div>
    );
};

export default ChatToolBar;
